import { render, staticRenderFns } from "./Irefi.vue?vue&type=template&id=0741cbdb&scoped=true&"
import script from "./Irefi.vue?vue&type=script&lang=js&"
export * from "./Irefi.vue?vue&type=script&lang=js&"
import style0 from "./Irefi.vue?vue&type=style&index=0&id=0741cbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741cbdb",
  null
  
)

export default component.exports